var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktopapp000000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 59,
    viewBox: "0 0 70 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1556 0H2.84437C2.09 0 1.36652 0.299675 0.833097 0.833098C0.299674 1.36652 0 2.09 0 2.84437V46.1926C0 46.947 0.299674 47.6705 0.833097 48.2039C1.36652 48.7373 2.09 49.037 2.84437 49.037H28.2446V55.3088H22.1861C21.8089 55.3088 21.4472 55.4587 21.1805 55.7254C20.9138 55.9921 20.7639 56.3538 20.7639 56.731V57.4421C20.7639 57.8193 20.9138 58.181 21.1805 58.4477C21.4472 58.7144 21.8089 58.8643 22.1861 58.8643H47.7855C48.1626 58.8643 48.5244 58.7144 48.7911 58.4477C49.0578 58.181 49.2076 57.8193 49.2076 57.4421V56.731C49.2076 56.3538 49.0578 55.9921 48.7911 55.7254C48.5244 55.4587 48.1626 55.3088 47.7855 55.3088H41.7554V49.037H67.1556C67.91 49.037 68.6335 48.7373 69.1669 48.2039C69.7003 47.6705 70 46.947 70 46.1926V2.84437C70 2.09 69.7003 1.36652 69.1669 0.833098C68.6335 0.299675 67.91 0 67.1556 0ZM38.1999 55.3088H31.8001V49.037H38.1999V55.3088ZM66.4445 44.0593C66.4445 44.4365 66.2947 44.7983 66.028 45.065C65.7613 45.3317 65.3995 45.4815 65.0223 45.4815H4.97765C4.60046 45.4815 4.23873 45.3317 3.97201 45.065C3.7053 44.7983 3.55547 44.4365 3.55547 44.0593V4.97765C3.55547 4.60046 3.7053 4.23873 3.97201 3.97201C4.23873 3.7053 4.60046 3.55547 4.97765 3.55547H65.0223C65.3995 3.55547 65.7613 3.7053 66.028 3.97201C66.2947 4.23873 66.4445 4.60046 66.4445 4.97765V44.0593Z",
    fill: "#000000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopapp000000);
export default __webpack_public_path__ + "static/media/desktopapp_000000.43871805858783515ed609ea08452665.svg";
export { ForwardRef as ReactComponent };